import { axiosApiInstance, intro_headers } from './_httpHeaders';

// U001: FAQ 목록 리스트
export const getFaqIntroList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectFaqIntroList.do`,
    params: {
      CFaqType: reqParam.CFaqType,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      searchText: reqParam.searchText,
    },
  });

// U002: 공지사항 인트로 목록 리스트
export const getNoticeIntroList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectNoticeIntroList.do`,
    params: {
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      searchText: reqParam.searchText,
    },
  });

// U003: 공지사항 인트로 상세 보기
export const getNoticeIntroDetailView = (noticeSeq) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectNoticeIntroDetailView.do`,
    params: {
      noticeSeq: noticeSeq,
    },
  });

// U004: 인트로 팝업
export const getAllNoticePopupNonLoginList = () =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectAllNoticePopupNonLoginList.do`,
    params: {},
  });

// U066: 공지사항 인트로 파일 다운로드
export const noticeIntrofileDown = (fileSeq) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/intro/noticeIntrofileDown.do`,
    params: {
      fileSeq: fileSeq,
    },
  });

// U0104: 스파로스 서비스 소개서 다운로드
export const documentFileDownload = (type) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/intro/documentFileDownload.do`,
    params: {
      docType: type,
    },
  });

// U1310: 인트로 상담신청 - 상담 신청 페이지 정책 조회
export const getPolicyMngtList = () =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectPolicyMngtList.do`,
    params: {},
  });

// U1311. 인트로 상담신청 - 상담 신청 등록
export const insertReqstConsult = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/insertReqstConsult.do`,
    data: {
      coBrno: dataParam.coBrno,
      cContactType: dataParam.cContactType,
      prvcRecmndTelno: dataParam.prvcRecmndTelno,
      prvcRecmndEmail: dataParam.prvcRecmndEmail,
      prvcGnrlNm: dataParam.prvcGnrlNm,
      dscsnDc: dataParam.dscsnDc,
      policySeq: dataParam.policySeq,
      policyAgreYn: dataParam.policyAgreYn,
      dscsnCoNm: dataParam.dscsnCoNm,
    },
  });

// U1312: 인트로 상담신청 - 서비스 이용약관
export const getTermsOfService = (policySeq) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectTermsOfService.do`,
    params: {
      policySeq: policySeq,
    },
  });

// U1313: 인트로 상담신청 - 개인정보처리방침
export const getPersonalTerms = (policySeq) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectPersonalTerms.do`,
    params: {
      policySeq: policySeq,
    },
  });
// FAQ 드롭다운 리스트
export const getIFaqTypeList = () =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/selectFaqTypeList.do`,
    params: {},
  });

// 인트로 서비스 제휴제안 - 제휴제안 등록
export const insertReqstProposal = (dataParam) =>
axiosApiInstance({
  method: 'post',
  headers: intro_headers,
  url: `${process.env.REACT_APP_API_URL}/user/intro/insertReqstProposal.do`,
  data: {
    prvcGnrlCoNm: dataParam.prvcGnrlCoNm,
    prvcRecmndTelno: dataParam.prvcRecmndTelno,
    prvcRecmndEmail: dataParam.prvcRecmndEmail,
    prvcGnrlNm: dataParam.prvcGnrlNm,
    prpTitle: dataParam.prpTitle,
    prpDc: dataParam.prpDc,
    prpPrps: dataParam.prpPrps,
    prvPolicySeq: dataParam.prvPolicySeq,
    prvPolicyAgreYn: dataParam.prvPolicyAgreYn,
    ntcnPolicySeq: dataParam.ntcnPolicySeq,
    ntcnPolicyChkYn: dataParam.ntcnPolicyChkYn,
  },
});

// 인트로 서비스 제휴제안 - 개인정보 수집 및 이용 동의 정책 조회
export const getProposalPrivacyPolicy = () =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/getProposalPrivacyPolicy.do`,
    params: {},
});

// 인트로 서비스 제휴제안 - 유의사항 정책 조회
export const getProposalNoticePolicy = () =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/intro/getProposalNoticePolicy.do`,
    params: {},
});
